import { Switch, Route } from 'react-router-dom';
import { PageRoute } from 'shared/components';
import {
  DeclineCredit,
  DeclineDti,
  DeclineWithFPayCrossSellContainer,
  DeclineFionaContainer,
  GenericDecline,
} from 'components/ErrorStates';

const DeclineRouter = () => {
  const base = '/applications/:uuid/decline';

  return (
    <Switch>
      <PageRoute exact path={base}>
        <GenericDecline />
      </PageRoute>
      <PageRoute path={`${base}/credit-score`}>
        <DeclineCredit />
      </PageRoute>
      <PageRoute path={`${base}/income`}>
        <DeclineDti />
      </PageRoute>

      {/* Special case since FPay decline design has no sidebar */}
      <Route path={`${base}/fpay`}>
        <DeclineWithFPayCrossSellContainer />
      </Route>
      <Route path={`${base}/fiona`}>
        <DeclineFionaContainer />
      </Route>
    </Switch>
  );
};

export default DeclineRouter;
